import styled from '@emotion/styled'
import tw from 'twin.macro'
import userBg from '../detail/assets/bg.png'

const StyledArticleDetail = styled.div`
  .detail-box {
    .detail-left {
      ${tw`flex-1`}
      .top-info {
        border-bottom-width: 1px;
        .detail-title {
          height: auto !important;
          font-weight: var(--font-weight-bolder);
          font-size: 28px;
          line-height: 36px;
          overflow: hidden !important;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          ${tw`mb-6`}
        }
        .big-article-author {
          font-size: var(--font-size-sm);
          color: var(--ow-color-gray-100);
          line-height: 22px;
          ${tw`my-6`}
        }
        .info-box {
          > div {
            ${tw`mr-6`}
            .number {
              font-weight: var(--font-weight-bolder);
              font-size: var(--font-size-sm);
              line-height: 22px;
              ${tw`mr-1`}
            }
            .text {
              white-space: nowrap;
              font-size: var(--font-size-sm);
              line-height: 22px;
            }
          }
          .forward-text {
            font-size: var(--font-size-sm);
            color: #95a8b9;
            line-height: 22px;
          }
          .article-author {
            height: auto !important;
            font-size: var(--font-size-sm);
            color: #94a7ba;
            line-height: 22px;
          }
          .article-date {
            height: auto !important;
            font-size: var(--font-size-sm);
            line-height: 22px;
            white-space: nowrap;
          }
          .article-link-title {
            font-size: var(--font-size-sm);
          }
          .article-link {
            height: auto !important;
            font-size: var(--font-size-sm);
            line-height: 22px;
            white-space: nowrap;
            cursor: pointer;
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          ${tw`flex items-center flex-wrap`}
        }
        ${tw`mb-6`}
      }
      .detail-content {
        height: auto !important;
        font-size: var(--font-size-md);
        color: var(--ow-color-gray-100);
        line-height: 28px;

        ${tw`pb-6`}
      }
      .article-detail-images {
        .img-content {
          ${tw`flex flex-wrap`}
          >div {
            height: auto !important;
            margin: 0 10px 10px 0;
            img {
              width: 410px !important;
              height: 310px !important;
              object-fit: cover;
              border-radius: 4px;
            }
          }
        }
        ${tw`flex mb-6`}
      }
    }
    @media screen and (max-width: 1200px) {
      .detail-left {
        width: 100%;
        padding: 0 20px;
      }
    }
    .detail-right {
      width: 325px;
      .user-box {
        width: 100%;
        background: var(--ow-color-white-100);
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        .header-info {
          padding: 40px 0 12px;
          background: url(${userBg}) no-repeat;
          background-size: 100% 100%;
          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            ${tw`mb-3`}
          }
          .nick-name {
            font-weight: var(--font-weight-bold);
            font-size: 18px;
            color: var(--ow-color-gray-100);
          }
          .author-name {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.6);
            margin-right: 4px;
          }
          .author-desc {
            padding: 0 16px;
            text-align: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.6);
            margin-top: 8px;
          }
          ${tw`flex flex-col items-center`}
        }
        .bottom-info {
          padding: 16px;
          > div {
            text-align: center;
            width: 108px;
            .number {
              font-weight: var(--font-weight-bold);
              font-size: var(--font-size-md);
              color: var(--ow-color-gray-100);
              margin-bottom: 12px;
            }
            .text {
              font-weight: 400;
              font-size: var(--font-size-sm);
              color: rgba(0, 0, 0, 0.4);
            }
          }
          > div + div {
            border-left: 1px solid var(--ow-color-neutral-300);
          }
          ${tw`flex `}
        }
        ${tw`mb-6`}
      }
    }
    @media screen and (max-width: 1200px) {
      .other-article {
        display: none;
      }
    }
    ${tw`mx-auto flex justify-between py-12`}
  }
  @media screen and (max-width: 1200px) {
    .detail-box {
      flex-direction: column-reverse;
      align-items: center;
    }
  }
`
export { StyledArticleDetail }
